import EsiaAuth from "./EsiaAuth";

export default EsiaAuth;